<template>
  <div class="form-builder-field-error">
    <template v-for="error in (validationField.$errors || [])" :key="error.$uid">
      <div class="error-msg">
        <span v-if="errors && errors[error.$validator]">{{ errors[error.$validator] }}</span>
        <span v-else-if="error.$validator === 'required'">{{ (fieldLabel || '').replace('*', '') }} {{ $t('common.isRequired') }}</span>
        <span v-else-if="error.$message">{{ error.$message }}</span>
        <span v-else>{{ $t('common.somethingIsWrong') }}...</span>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "FormBuilderFieldError",
  props: {
    validationField: {
      type: Object
    },
    fieldLabel: {
      type: String
    },
    errors: {}
  }
}
</script>

<style lang="scss">
@import "FormBuilderFieldError";
</style>
